import { each } from 'lodash'
import queryString from 'query-string'
import { setClarityTags } from '../services/util'

/**
 * API docs: https://legalnature.docs.apiary.io/#reference/user-information/profile/view-a-profile-detail
 */

export const parseUserResponse = function (object) {
  return {
    'id': object.id,
    'firstName': object.first_name,
    'lastName': object.last_name,
    'email': object.email,
    'phone': object.phone,
    'isPro': object.is_pro,
    'companies': object.companies,
    'avatarUrl': object.avatar_url,
    'bingConversion': object.bing_conversion,
    'subscriptionAccess': object.subscription_access,
    'facebookConversion': object.facebook_conversion,
    'localeId': object.locale_id,
    'checkoutTest': object.checkout_test,
    'documentsInProgress': object.documents_in_progress,
    'registered': object.registered,
    'formAbandonTest': object.form_abandon_test,
    'formTest': object.form_test,
    'defaultState': object.default_state
  }
}

export const parseCardResponse = function (object) {
  return {
    'id': object.id,
    'last4': object.card_last_4,
    'creditCardNumber': object.creditCardNumber,
    'cardName': object.card_name,
    'expirationDate': object.card_expires_in,
    'cardType': object.card_type,
    'isPrimary': object.is_primary
  }
}

export const setClarityUser = ({ displayName, email, uid }) => {
  if (window && window.clarity) {
    if (uid) {
      try {
        window.clarity('identify', String(uid), undefined, undefined, displayName)
      } catch (e) {
        console.error(e)
      }
    }
    setClarityTags({ displayName, email, uid })
  }
}

export const setGAUser = (uid, email) => {
  if (window && window.$nuxt && window.$nuxt.$gtag) {
    if(email){
      window.$nuxt.$gtag.set({
        'user_id': uid,
        'user_data': {
          'email': email
        }
      })
    }
    else {
      window.$nuxt.$gtag.set({
        'user_id': uid
      })
    }
  }
}

// Hindsight's identify, which plugins/hindsight.js provides when capture is on.
// A profile can load before that plugin runs (clarity-identify starts its
// request first), so its identity waits here until then.
let hindsightIdentify = null
let waitingHindsightIdentity = null
// The visitor this page last named to Hindsight. The wizard loads the profile
// twice (User.findOrCreate and getUser), so a repeat is skipped.
let hindsightVisitor = null

export const provideHindsightIdentify = (identify) => {
  hindsightIdentify = identify
  if (waitingHindsightIdentity) identify(waitingHindsightIdentity)
  waitingHindsightIdentity = null
}

// Names a registered visitor to Hindsight. Guests stay unidentified: logging
// into an existing account merges a guest's temporary user into it and
// changes the ID, which would split the Hindsight session.
export const setHindsightUser = (profile, source) => {
  if (typeof window === 'undefined') return
  if (!profile || !profile.registered || !profile.id || profile.id === hindsightVisitor) return
  hindsightVisitor = profile.id
  const identity = { visitorId: profile.id, source }
  if (hindsightIdentify) hindsightIdentify(identity)
  else waitingHindsightIdentity = identity
}

async function getUser(client, params) {
  try {
    const requestParams = { ...(params || {}) }

    if (process.client) {
      const browserTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if (browserTimeZone) {
        requestParams.time_zone = browserTimeZone
      }
    }

    let url = '/profile'

    if (Object.keys(requestParams).length > 0) {
      url += '?'+ queryString.stringify(requestParams)
    }
    const response = await client.$get(url)
    const responseUser = parseUserResponse(response)
    setClarityUser({
      displayName: responseUser.firstName + ' ' + responseUser.lastName,
      email: responseUser.email,
      uid: responseUser.id
    })
    setGAUser(responseUser.id, responseUser.email)
    setHindsightUser(response, 'profile')
    return responseUser
  } catch (error) {
    throw error
  }
}

export default {
  getUser: getUser
}
